import { AdConfigs } from "@/app/layout/useAdManager";

export const SEARCH_ADS: AdConfigs = {
  Horsezone_Search_Top: {
    unitId: "/23304440151/Horsezone_Search_Top",
    elementId: "div-gpt-ad-1752529660415-0",
    sizes: [
      {
        width: 728,
        height: 90,
      },
      {
        width: 320,
        height: 100,
      },
    ],
    height: 100,
    width: 320,
    noBackground: true,
    noPadding: true,
  },
  Horsezone_Search_Side_1: {
    unitId: "/23304440151/Horsezone_Search_Side_1",
    elementId: "div-gpt-ad-1748918149709-0",
    width: 160,
    height: 600,
    noBackground: true,
    noPadding: true,
  },
  Horsezone_Search_Side_2: {
    unitId: "/23304440151/Horsezone_Search_Side_2",
    elementId: "div-gpt-ad-1748918191508-0",
    width: 160,
    height: 600,
    noBackground: true,
    noPadding: true,
  },
  Horsezone_Search_Side_3: {
    unitId: "/23304440151/Horsezone_Search_Side_3",
    elementId: "div-gpt-ad-1781658850279-0",
    width: 300,
    height: 250,
    noBackground: true,
    noPadding: true,
  },
  Horsezone_Search_Bottom: {
    unitId: "/23304440151/Horsezone_Search_Bottom",
    elementId: "div-gpt-ad-1748918663684-0",
    sizes: [
      {
        width: 728,
        height: 90,
      },
      {
        width: 320,
        height: 100,
      },
    ],
    height: 100,
    width: 320,
    noPadding: true,
  },
};
